

<div class="ed-content-block-head">
  <h2>
    @if (content.headline) {
      {{ content.headline }}
    } @else {
      <ng-container i18n>Text des Inhabers</ng-container>
    }
    <app-tooltip i18n>
        Dies ist ein individueller Text des Domaineigentümers, der möglicherweise nicht in Ihrer Sprache ist.
    </app-tooltip>
  </h2>
</div>

<div [innerHTML]="content.text"></div>
